export const GET_PACKAGING_REQUEST = "GET_PACKAGING_REQUEST";
export const GET_PACKAGING_SUCCESS = "GET_PACKAGING_SUCCESS";
export const GET_PACKAGING_FAILURE = "GET_PACKAGING_FAILURE";

export const GET_DELETE_PACKAGING_REQUEST = "GET_DELETE_PACKAGING_REQUEST";
export const GET_DELETE_PACKAGING_SUCCESS = "GET_DELETE_PACKAGING_SUCCESS";
export const GET_DELETE_PACKAGING_FAILURE = "GET_DELETE_PACKAGING_FAILURE";


export const CREATE_PACKAGING_REQUEST = "CREATE_PACKAGING_REQUEST";
export const CREATE_PACKAGING_SUCCESS = "CREATE_PACKAGING_SUCCESS";
export const CREATE_PACKAGING_FAILURE = "CREATE_PACKAGING_FAILURE";

export const EDIT_PACKAGING_REQUEST = "EDIT_PACKAGING_REQUEST";
export const EDIT_PACKAGING_SUCCESS = "EDIT_PACKAGING_SUCCESS";
export const EDIT_PACKAGING_FAILURE = "EDIT_PACKAGING_FAILURE";

export const UPLOAD_PACKAGING_REQUEST = "UPLOAD_PACKAGING_REQUEST";
export const UPLOAD_PACKAGING_SUCCESS = "UPLOAD_PACKAGING_SUCCESS";
export const UPLOAD_PACKAGING_FAILURE = "UPLOAD_PACKAGING_FAILURE";

export const UPLOAD_FG_REQUEST = "UPLOAD_FG_REQUEST";
export const UPLOAD_FG_SUCCESS = "UPLOAD_FG_SUCCESS";
export const UPLOAD_FG_FAILURE = "UPLOAD_FG_FAILURE";
